import { SummaryPackageFeatureTransformers } from './types';
import { Packages } from '~shared/constants/pricing';

import StandardMonthlyFeatureTransformer from './StandardMonthly';
import TeamPremierFeatureTransformer from './TeamPremier';
import TeamAdvantageFeatureTransformer from './TeamAdvantage';
import EnterpriseFeatureTransformer from './Enterprise';
import PremierAnnualFeatureTransformer from './PremierAnnual';
import AdvantageAnnualFeatureTransformer from './AdvantageAnnual';

/**
 * A map of package to the feature transformer for that package.
 * This handles the defaults, but an experiment can override a transformer
 * for any one package or multiple
 */
const SummaryFeatureTransformers: SummaryPackageFeatureTransformers = {
  [Packages.StandardMonthly]: StandardMonthlyFeatureTransformer,
  [Packages.AdvantageAnnual]: AdvantageAnnualFeatureTransformer,
  [Packages.TeamAdvantage]: TeamAdvantageFeatureTransformer,
  [Packages.TeamPremier]: TeamPremierFeatureTransformer,
  [Packages.Enterprise]: EnterpriseFeatureTransformer,
  [Packages.PremierAnnual]: PremierAnnualFeatureTransformer,
};

export default SummaryFeatureTransformers;
